import { Controller } from 'stimulus';

class MegaMenuController extends Controller {
  connect() {
    this.linkTargets.forEach((link) => {
      link.addEventListener('click', this.onLinkClick.bind(this));
    });
  }

  disconnect() {
    this.linkTargets.forEach((link) => {
      link.removeEventListener('click', this.onLinkClick.bind(this));
    });
  }

  onLinkClick(event) {
    const { currentTarget } = event;

    if (!currentTarget.classList.contains('has-children')) {
      return true;
    }

    event.preventDefault();

    const parentItem = currentTarget.closest('li');

    if (!parentItem) {
      throw new Error('Could not find parentItem from the currentTarget');
    }

    const dropdown = parentItem.querySelector('[data-target*="mega-menu.dropdown"]');

    if (!dropdown) {
      throw new Error('Could not find dropdown from the currentTarget');
    }

    this.closeAllDropdowns();

    this.openDropdown(dropdown);

    return false;
  }

  closeAllDropdowns() {
    this.dropdownTargets.forEach((dropdown) => {
      dropdown.classList.remove('is-open');
    });
  }

  openDropdown(dropdownElement) {
    dropdownElement.classList.add('is-open');

    this.element.style.minHeight = `${dropdownElement.offsetHeight}px`;
  }
}

MegaMenuController.targets = [
  'link',
  'dropdown',
];

export default MegaMenuController;
